<template>
  <div class="flex flex-row justify-between items-center py-3 w-full">
    <div class="flex flex-col justify-start items-stretch">
      <p class="w-full text-lg mr-4">
        {{ item.quantity }} x {{ item.product.shopfront_name }}
      </p>
      <p v-if="item.hire_price" class="text-sm text-gray-500">
        <currency-value :value="item.hire_price"></currency-value>
      </p>
      <p v-if="item.price_error" class="text-sm text-red-500">
        Error calculating price
      </p>
    </div>
    <button @click="remove" class="text-red-500">
      <v-icon name="ri-close-fill"></v-icon>
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { BookingItem } from "../../models/store";
import { useCartStore } from "../../stores/cart";
import CurrencyValue from "../CurrencyValue.vue";

export default defineComponent({
  components: {
    CurrencyValue,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    saleItem: {
      type: Boolean,
      required: true,
    },
  },
  setup() {
    const cartStore = useCartStore();
    return {
      cartStore,
    };
  },
  methods: {
    remove() {
      this.cartStore.remove({
        item: this.item as BookingItem,
        saleItem: this.saleItem,
      });
    },

    decrement(item: BookingItem) {
      this.cartStore.decrement({ item, saleItem: this.saleItem });
    },

    increment(item: BookingItem) {
      this.cartStore.increment(item);
    },
  },
});
</script>

<style scoped></style>
